<h2 matDialogTitle>{{data.title}}</h2>
<mat-dialog-content>
  <p>{{data.description}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button matDialogClose color="warn" (click)="ok()">{{data.confirmButtonText}}</button>
  <button mat-button matDialogClose color="primary" (click)="cancel()">{{data.cancelButtonText}}</button>
</mat-dialog-actions>